// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___N4zom","title":"style__title___3NcpZ","subtitle":"style__subtitle___p2HPV","inputContainer":"style__inputContainer___w2g6V","inputError":"style__inputError___Xkzg8","input":"style__input___3mbSy","inputMessage":"style__inputMessage___2n373","inputPassword":"style__inputPassword___1U6GP","error":"style__error___wiw7w","button":"style__button___1nhIO","text":"style__text___2rwHx","textBold":"style__textBold___oqHKU","backButton":"style__backButton___VTfjM"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/booster-reset-password/style.css
// module id = 1243
// module chunks = 0